export default __webpack_public_path__ + "static/impress-visitors-sophisticated-safety-induction-life-saving-rules-b901494e0614135a7ee6d0033abf9371.jpg";